import type { Context } from 'react';
import { createContext, useContext } from 'react';

import { PHASE } from '../constants';
import type { SubscriptionContextValue } from '../lazy/types';
import { type Listener, LISTENERS } from './listeners';
import { createSubscribe } from './utils';

let CURRENT_PHASE = PHASE.PAINT;

export const setCurrent = (phase: number): void => {
	CURRENT_PHASE = phase;
	LISTENERS.slice(0).forEach((listener: Listener) => listener(phase));
};

interface LazyPhaseContextApi extends SubscriptionContextValue {
	api: {
		resetPhase: () => void;
		startNextPhase: () => void;
	};
}

export const LazyPhaseContext: Context<LazyPhaseContextApi> = createContext<LazyPhaseContextApi>({
	subscribe: createSubscribe(LISTENERS),
	currentValue: () => CURRENT_PHASE,
	api: {
		startNextPhase: () => {
			setCurrent(PHASE.AFTER_PAINT);
		},
		resetPhase: () => setCurrent(PHASE.PAINT),
	},
});

export const useLazyPhase = (): {
	resetPhase: () => void;
	startNextPhase: () => void;
} => {
	const v = useContext(LazyPhaseContext);

	return v.api;
};
